// import { motion } from "framer-motion";
// import { Zap, BarChart3, Users, ArrowRight, CheckCircle } from "lucide-react";
// import { Link } from "react-router-dom";

// const fadeInUp = {
//   initial: { opacity: 0, y: 20 },
//   animate: { opacity: 1, y: 0 },
//   transition: { duration: 0.5 },
// };

// export default function Products() {
// const products = [
//   {
//     icon: BarChart3,
//     title: "ERP System",
//     link: "/Erp",
//     description:
//       "Enterprise Resource Planning for complete business management",
//     features: [
//       "Inventory Management",
//       "Financial Management",
//       "Supply Chain Management",
//       "Human Resources",
//       "Real-time Analytics",
//       "Multi-branch Support",
//     ],
//   },
//   {
//     icon: Users,
//     title: "CRM System",
//     link: "/Crm",
//     description:
//       "Customer Relationship Management for better customer engagement",
//     features: [
//       "Contact Management",
//       "Sales Pipeline",
//       "Customer Support",
//       "Email Integration",
//       "Lead Scoring",
//       "Customer Analytics",
//     ],
//   },
//   {
//     icon: Zap,
//     title: "HRM System",
//     link: "/Hrm",
//     description: "Human Resource Management for streamlined HR operations",
//     features: [
//       "Employee Management",
//       "Attendance Tracking",
//       "Payroll Management",
//       "Performance Reviews",
//       "Leave Management",
//       "Recruitment Tools",
//     ],
//   },
//   {
//     icon: BarChart3,
//     title: "Billing & Invoicing Software",
//     link: "/Billing",
//     description:
//       "Smart billing solution for fast, accurate, and compliant invoicing",
//     features: [
//       "GST / Tax Compliant Invoices",
//       "Auto Invoice Generation",
//       "Customer & Product Management",
//       "Payment Tracking",
//       "Discount & Tax Rules",
//       "Reports & Statements",
//     ],
//   },

// ];

//   return (
//     <>
//       {/* ===== GLOBAL STYLES INSIDE SAME FILE ===== */}
//       <style>{`
//         :root {
//           --primary: #1e3a8a;     /* Navy Blue */
//           --secondary: #2563eb;   /* Tech Blue */
//           --background: #ffffff;
//           --foreground: #0f172a;
//           --card: #ffffff;
//           --border: #e5e7eb;
//           --muted: #64748b;
//         }

//         body {
//           background-color: var(--background);
//           color: var(--foreground);
//           font-family: Inter, system-ui, sans-serif;
//         }

//         .bg-primary { background-color: var(--primary); }
//         .bg-secondary { background-color: var(--secondary); }
//         .text-primary { color: var(--primary); }
//         .bg-card { background-color: var(--card); }
//         .border-border { border-color: var(--border); }
//         .text-muted { color: var(--muted); }
//       `}</style>

//       <main className="bg-white">
//         {/* Hero */}
//         <section className="bg-gradient-to-r from-[#071c34] to-[#0f2a44] text-white py-20 sm:py-28">
//           <div className="max-w-7xl mx-auto px-4 text-center">
//             <motion.div {...fadeInUp}>
//               <h1 className="text-4xl sm:text-5xl font-bold mb-6">
//                 Our Products
//               </h1>
//               <p className="text-xl opacity-90 max-w-3xl mx-auto">
//                 Powerful enterprise solutions designed to streamline your
//                 business operations
//               </p>
//             </motion.div>
//           </div>
//         </section>

//         {/* Products */}
//         <section className="py-20 bg-white">
//           <div className="max-w-7xl mx-auto px-4">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//               {products.map((product, index) => {
//                 const Icon = product.icon;
//                 return (
//                   <motion.div
//                     key={index}
//                     initial="initial"
//                     animate="animate"
//                     variants={{
//                       ...fadeInUp,
//                       transition: { delay: index * 0.1 },
//                     }}
//                     className="bg-card border border-border rounded-xl p-8 hover:shadow-xl transition group"
//                   >
//                     <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary transition">
//                       <Icon
//                         className="text-primary group-hover:text-white"
//                         size={32}
//                       />
//                     </div>

//                     <h3 className="text-2xl font-bold mb-2">{product.title}</h3>
//                     <p className="text-muted mb-6">{product.description}</p>

//                     <div className="space-y-3 mb-8">
//                       {product.features.map((feature, idx) => (
//                         <div key={idx} className="flex gap-2">
//                           <CheckCircle
//                             size={16}
//                             className="text-primary mt-1"
//                           />
//                           <span className="text-sm">{feature}</span>
//                         </div>
//                       ))}
//                     </div>

//                     <Link
//                       to={product.link}
//                       className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all"
//                     >
//                       Learn More <ArrowRight size={18} />
//                     </Link>
//                   </motion.div>
//                 );
//               })}
//             </div>
//           </div>
//         </section>

//         {/* CTA */}
//         {/* <section className="bg-gradient-to-r from-primary to-secondary py-20 text-white text-center"> */}
//         <section className="bg-gradient-to-r from-[#1e3a8a] to-[#2563eb] py-20 text-white text-center">
//           <motion.div {...fadeInUp} className="max-w-4xl mx-auto px-4">
//             <h2 className="text-3xl sm:text-4xl font-bold mb-4">
//               Interested in Our Products?
//             </h2>
//             <p className="opacity-90 mb-8">
//               Schedule a demo to see how our products can benefit your business
//             </p>
//             <Link
//               to="/contact"
//               className="inline-flex items-center gap-2 bg-white text-primary px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
//             >
//               Schedule Demo <ArrowRight size={18} />
//             </Link>
//           </motion.div>
//         </section>
//       </main>
//     </>
//   );
// }

import { motion } from "framer-motion";
import {
  Zap,
  BarChart3,
  Users,
  ArrowRight,
  CheckCircle2,
  Package,
  ShieldCheck,
  Terminal,
  Database,
  Layers,
  Code
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function Products() {
 const products = [
   {
     icon: BarChart3,
     title: "ERP System",
     link: "/Erp",
     description:
       "Enterprise Resource Planning for complete business management",
     features: [
       "Inventory Management",
       "Financial Management",
       "Supply Chain Management",
       "Human Resources",
       "Real-time Analytics",
       "Multi-branch Support",
     ],
   },
   {
     icon: Users,
     title: "CRM System",
     link: "/Crm",
     description:
       "High-performance relationship management with integrated billing capabilities.",
     features: [
       "Contact Management",
       "Sales Pipeline & Analytics",
       "Customer Support Portal",
       "Automated Billing Integration",
       "Lead Scoring Engine",
       "React & PHP Based Architecture",
     ],
   },
   {
     icon: Zap,
     title: "HRM System",
     link: "/Hrm",
     description: "Human Resource Management for streamlined HR operations",
     features: [
       "Employee Management",
       "Attendance Tracking",
       "Payroll Management",
       "Performance Reviews",
       "Leave Management",
       "Recruitment Tools",
     ],
   },
   {
     icon: BarChart3,
     title: "Billing & Invoicing Software",
     link: "/Billing",
     description:
       "Smart billing solution for fast, accurate, and compliant invoicing developed with MySQL backend.",
     features: [
       "GST / Tax Compliant Invoices",
       "Auto Invoice Generation",
       "Customer & Product Management",
       "Real-time Payment Tracking",
       "Discount & Tax Rules",
       "Comprehensive Reports",
     ],
   },
 
 ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100 text-[#0f172a]">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/95 to-transparent z-10" />

        {/* Technical Grid Overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none z-10"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full z-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Engineering Lab
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight leading-tight">
              Enterprise{" "}
              <span className="text-indigo-400">Software Products.</span>
            </h1>
            <p className="text-lg text-slate-300 max-w-2xl font-light leading-relaxed">
              We architect high-fidelity software ecosystems and multilingual
              data pipelines engineered for global scalability and
              mission-critical performance.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= PRODUCTS GRID ================= */}
      <section className="py-24 bg-[#f8fafc]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8">
            {products.map((product, index) => (
              <motion.div
                key={index}
                {...fadeInUp}
                transition={{ delay: index * 0.1 }}
                className="group bg-white border border-slate-200 rounded-2xl p-8 md:p-12 shadow-sm hover:shadow-xl hover:border-indigo-100 transition-all duration-300 flex flex-col h-full text-left"
              >
                <div className="w-16 h-16 rounded-2xl bg-slate-50 flex items-center justify-center mb-8 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                  <product.icon
                    size={30}
                    className="text-indigo-600 group-hover:text-white transition-colors"
                  />
                </div>

                <h3 className="text-2xl font-bold mb-4 tracking-tight text-[#0f2a44]">
                  {product.title}
                </h3>
                <p className="text-slate-500 text-base font-light leading-relaxed mb-10 flex-grow">
                  {product.description}
                </p>

                <div className="grid sm:grid-cols-2 gap-y-4 gap-x-6 mb-12 border-t border-slate-50 pt-10">
                  {product.features.map((feature, idx) => (
                    <div
                      key={idx}
                      className="flex gap-3 items-center text-[13px] font-medium text-slate-700"
                    >
                      <CheckCircle2
                        size={16}
                        className="text-indigo-600 shrink-0"
                      />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to={product.link}
                  className="inline-flex items-center gap-2 font-bold text-indigo-600 group-hover:gap-3 transition-all text-xs uppercase tracking-[0.2em]"
                >
                  Technical Documentation <ArrowRight size={14} />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= TRUST & QUALITY ================= */}
      <section className="py-20 bg-white border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-12">
          <div className="max-w-xl text-left">
            <h2 className="text-3xl font-bold mb-4 tracking-tight text-[#0f2a44]">
              Hardened Production Environments
            </h2>
            <p className="text-slate-500 font-light leading-relaxed">
              Our product architectures are built on SOC2-compliant
              infrastructures, ensuring your enterprise data remains isolated
              and secure throughout the operational lifecycle.
            </p>
          </div>
          <div className="flex flex-wrap gap-6">
            <div className="px-6 py-4 bg-slate-50 rounded-2xl border border-slate-100 flex items-center gap-3">
              <ShieldCheck className="text-indigo-600" size={20} />
              <span className="text-xs font-bold uppercase tracking-widest text-[#0f2a44]">
                ISO Certified
              </span>
            </div>
            <div className="px-6 py-4 bg-slate-50 rounded-2xl border border-slate-100 flex items-center gap-3">
              <Database className="text-indigo-600" size={20} />
              <span className="text-xs font-bold uppercase tracking-widest text-[#0f2a44]">
                MySQL Optimized
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="bg-[#0f172a] py-28 text-center relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(circle_at_center,_#4f46e51a_0%,_transparent_70%)]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <motion.div {...fadeInUp}>
            <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white tracking-tight leading-tight">
              Ready to Orchestrate Your <br />
              <span className="text-indigo-400 text-left">
                Digital Operations.
              </span>
            </h2>
            <p className="text-slate-400 mb-12 text-lg font-light leading-relaxed mx-auto max-w-2xl">
              Discuss your technical roadmap with our engineering lead and
              discover how we can optimize your infrastructure.
            </p>
            <div className="flex justify-center gap-4">
              <Link
                to="/contact"
                className="bg-white text-[#0f172a] px-10 py-4 rounded-xl font-black text-sm uppercase tracking-widest hover:bg-indigo-50 transition-all shadow-xl shadow-black/20"
              >
                Schedule Architecture Demo
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
}